'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: '<input ref="valueInput" :value="value" />',
    model: {
        event: 'changemodel'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-grid-vue-wrapper/~/@progress/kendo-base-components-vue-wrapper/dist/es/kendo-base-input-component/index.js
// module id = 481
// module chunks = 45